import React from "react";
import "./heading.css";

export const Heading = () => {
  return (
    <>
      <div className="heading-upper">
        <div className="name">
          <div className="BHAKTI-SASHTRI">BHAKTI VRIKSHA</div>
        </div>
      </div>
      <div className="flex-col text-center">
        <div className="BhaktiVriksha-section-heading">
          <h1 className="BhaktiVriksha-heading">
            Bhakti Vriksha – Spiritual Growth in Small Groups
          </h1>
          <h2 className="BhaktiVriksha-subheading">
            Join Weekly Sessions for Gita Study and Devotee Association
          </h2>
        </div>
        <h1 className="items-center md:text-[48px] text-[20px] mt-3 text-red font-semibold">
          Bhakti-Vriksha at ISKCON Vijayawada:
        </h1>
        <h1 className="md:text-[38px] text-[20px] text-red font-bold">
          Growing in Devotion
        </h1>
      </div>
    </>
  );
};
